import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';

const SlashMenu = ({ options, highlightedIndex, onHover, onSelect }) => (
  <div
    className={styles['slash-menu']}
    onMouseDown={e => e.preventDefault()}
  >
    <span className={styles['slash-menu__header']}>
      Templates
    </span>
    <div className={styles['slash-menu__list']}>
      {options.map((option, index) => (
        <button
          key={option.label}
          type="button"
          className={cn(styles['slash-menu__item'], {
            [styles['slash-menu__item--highlighted']]: highlightedIndex === index,
          })}
          onMouseEnter={() => onHover(index)}
          onMouseLeave={() => onHover(-1)}
          onMouseDown={e => {
            e.preventDefault();
            onSelect(option);
          }}
        >
          <span className={styles['slash-menu__item-label']}>
            {option.label}
          </span>
          <span className={styles['slash-menu__item-desc']}>
            {option.text}
          </span>
        </button>
      ))}
    </div>
  </div>
);

SlashMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  highlightedIndex: PropTypes.number.isRequired,
  onHover: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SlashMenu;
